import { Button } from 'components'
import { useAlert } from 'providers/confirmationModal'
import { useUsersActions } from 'providers'
import { DCProgressModal } from 'components/ConfirmationModals/DCProgressModal'
import { useCallback } from 'react'
import { noop } from 'utils'
import { DCProgressProps } from 'types'
import { BasicConfirmationModal } from 'components/ConfirmationModals/BasicConfirmationModal'

export type DCProgressBtnProps = {
  userId: string
  dcProgress?: string
  disabled?: boolean
  onDone?: (message: string) => void
  onError?: (message: string) => void
}

export const DCProgressBtn = ({
  userId,
  dcProgress,
  disabled = false,
  onDone = noop,
  onError = noop,
}: DCProgressBtnProps) => {
  const {
    read: readUser,
    account: { updateProgress },
  } = useUsersActions()
  const {
    createAlert,
    finalizeConfirm,
    abortConfirm,
    handleCancel,
    setDisabled,
    interceptConfirm,
  } = useAlert()
  const progressUser = useCallback(
    async (lessonNumber) => {
      //needs to be a .then because when the user updates, this component won't exist, but the modal still will need to be closed

      await updateProgress({ userId: userId, lessonNumber: lessonNumber })
      await new Promise((res, rej) => {
        setTimeout(
          () =>
            readUser({ id: userId })
              .then(() => {
                res(true)
              })
              .catch((error) => {
                rej(error)
              }),
          2000
        )
      })
    },
    [userId, updateProgress, readUser]
  )

  const setProgress = useCallback(
    (newProgress: DCProgressProps | undefined) => {
      if (newProgress === undefined) {
        setDisabled(true)
      } else {
        setDisabled(false)
        interceptConfirm(() => {
          finalizeConfirm()
          setTimeout(() => {
            console.log('createAlert')
            createAlert({
              content: (
                <BasicConfirmationModal
                  header="Please confirm new student progress"
                  body={`Your student will be set to start ${newProgress.displayName}. Is this correct?`}
                  handleCancel={handleCancel}
                />
              ),
              confirmText: 'Confirm',
            })
            interceptConfirm(() => {
              progressUser(newProgress.lessonNumber)
                .then(() => {
                  finalizeConfirm()
                  onDone('User Progress has been updated')
                })
                .catch((e) => {
                  abortConfirm('User Progress update Failed, Try Again!')
                  onError('User Progress update Failed, Try Again!')
                })
            })
          }, 10)
        })
      }
    },
    [
      setDisabled,
      interceptConfirm,
      finalizeConfirm,
      createAlert,
      handleCancel,
      progressUser,
      onDone,
      abortConfirm,
      onError,
    ]
  )

  const handleClick = () => {
    createAlert({
      content: (
        <DCProgressModal
          name="dcProgress"
          dcProgress={dcProgress}
          set={setProgress}
          cancel={handleCancel}
        />
      ),
      confirmText: 'Save',
    })
    setDisabled(true) // Setting to true after modal is created because it starts with nothing selected
  }
  return (
    <Button
      type="button"
      variant="buttons.outline"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
      }}
      disabled={disabled}
      onClick={handleClick}>
      <span>Adjust Digital Course position</span>
    </Button>
  )
}
